import Editor from './editor';

export { Editor };


// WEBPACK FOOTER //
// ./packages/kendo-editor-react-wrapper/src/index.ts